import { TTranslate } from './types';

export default function getWeekDaysShort(T: TTranslate, firstDayOfWeek = 0) {
  let weekdays = [
    T.translate('SU'),
    T.translate('MO'),
    T.translate('TU'),
    T.translate('WE'),
    T.translate('TH'),
    T.translate('FR'),
    T.translate('SA'),
  ];

  if (firstDayOfWeek > 0) {
    weekdays = weekdays.concat(weekdays.splice(0, firstDayOfWeek));
  }

  return weekdays;
}
